export const copy = () => ({
  type: "COPY",
})
